
export const set_user_details = (data) => {
    
    return {
        type: "set-user-info",
        user: data
    }
}

export const reset_user_details = (data) => {
//debugger;
    return {
        type: "logout",
        user: data
    }
}

export const thunk_set_user = (userInfo) => {
    //debugger;
    return function (dispatch, getstate) {
        
        dispatch(set_user_details(userInfo))
    }
}

export const thunk_reset_user = (userInfo) => {
    return function (dispatch, getstate) {
        dispatch(reset_user_details(userInfo))
    }
}

export const setSelectedOrganization = (org) => ({
    type: "set-selected-organization",
    payload: org
});

export const setAvailableOrganizationData = (orgData) => ({
    type: "set-available-organization-data",
    payload: orgData
});